export default __webpack_public_path__ + "static/media/33.b28df7fa.png";